import SkeletonText from './SkeletonText';
import styled from 'styled-components';
import { GYPSUM, KOALA } from 'HubStyleTokens/colors';
export const ShinySkeletonText = styled(SkeletonText).withConfig({
  displayName: "ShinySkeletonText",
  componentId: "z1lgki-0"
})(["background:", ";background:linear-gradient(to right,", ",", " 20%,", " 40%);background-size:1200px;"], GYPSUM, GYPSUM, KOALA, GYPSUM);